import contentful from "libraries/contentful/client";
import ContentfulEntry from "models/data/contentful/ContentfulEntry";
import { get } from "lodash";

class ContentfulTag {
  static default = {
    name: "",
  };

  static id = (contentfulTag) => ContentfulEntry.id(contentfulTag);

  static tagName = (contentfulTag) => {
    const name = get(contentfulTag, "name", ContentfulTag.default.name);
    return name;
  };

  static async fetchWithId(tagId) {
    const tag = await contentful.getTag(tagId);
    return tag;
  }
}

export default ContentfulTag;
